  // Fonction pour formater le texte avec split par underscore
  export const formatTypoloText = (text) => {
    if (!text) return null;
    
    const parts = text.split('_');
    
    if (parts.length === 1) {
      // Pas d'underscore, retourne le texte en gras
      return <strong>{parts[0]}</strong>;
    }
    
    // Au moins un underscore
    return (
      <>
        <strong>{parts[0]}</strong>
        {parts.slice(1).map((part, index) => (
          <span key={index}> {part}</span>
        ))}
      </>
    );
  };